export const MgmRedeemCodePageResourcesEn = {
    title: "Redeem <b>code</b>",

    description: "You may <b>redeem goodie code</b> here.",

    codePlaceholder: "Enter the code",

    nextButtonText: "Next",

    codeInputRequiredMessage: "Please enter a valid goodie code",
};
